import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { providersService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { countries } from "utils/utils";
import "./Providers.scss";
import * as expensesActions from "actions/expensesActions";
import { withTranslation } from "react-i18next";

class ProviderEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let provider = {
			name: "",
			vat_number: "",
			address: "",
			postal_code: "",
			province: "",
			country_iso: "ES",
			city: "",
			phone: "",
			web: "",
			email: "",
		};

		let isEdit = false;

		if (props.provider) {
			provider = props.provider;
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			provider,
		};
	}

	handleChange = (event) => {
		const { provider } = this.state;

		this.setState({
			provider: {
				...provider,
				[event.target.id]: event.target.value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		let response = "";
		const props = this.props;

		// if edit => update; else => new
		if (this.state.isEdit) {
			response = await providersService.update(this.state.provider);
		} else {
			response = await providersService.add(this.state.provider);
		}

		//console.log(response);

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
					this.props.getProviders();
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	render() {
		const { provider } = this.state;
		const option_iso_countries =
			countries.length > 0 &&
			countries.map((item, i) => {
				return (
					<option key={i} value={item.iso}>
						{item.name}
					</option>
				);
			}, this);

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<Row>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="name">
								<FormLabel>
									{this.props.t('providers.form.nameLabel')}{" "}
									<span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.name}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.namePlaceholder')}
									isInvalid={this.checkValidField("name")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.name}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="vat_number">
								<FormLabel>
									{this.props.t('providers.form.cif')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.vat_number}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.cif')}
									isInvalid={this.checkValidField("vat_number")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.vat_number}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={8}>
							<FormGroup className="form-group" controlId="address">
								<FormLabel>
									{this.props.t('providers.form.address')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.address}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.addressPlaceholder')}
									isInvalid={this.checkValidField("address")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.address}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={4}>
							<FormGroup className="form-group" controlId="postal_code">
								<FormLabel>
									{this.props.t('providers.form.postalCode')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.postal_code}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.postalCode')}
									isInvalid={this.checkValidField("postal_code")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.postal_code}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={4}>
							<FormGroup className="form-group" controlId="city">
								<FormLabel>
									{this.props.t('providers.form.city')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.city}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.city')}
									isInvalid={this.checkValidField("city")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.city}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={4}>
							<FormGroup className="form-group" controlId="province">
								<FormLabel>
									{this.props.t('providers.form.province')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.province}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.province')}
									isInvalid={this.checkValidField("province")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.province}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6} md={4}>
							<FormGroup className="form-group" controlId="country_iso">
								<FormLabel>
									{this.props.t('providers.form.country')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									placeholder={this.props.t('providers.form.country')}
									value={provider.country_iso}
									onChange={this.handleChangeSearch}
									as="select"
								>
									{option_iso_countries}
								</FormControl>
								<FormControl.Feedback type="invalid">
									{this.state.errors.country_iso}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="email">
								<FormLabel>
									{this.props.t('providers.form.email')} <span className="label-required">*</span>
								</FormLabel>
								<FormControl
									type="text"
									value={provider.email}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.email')}
									isInvalid={this.checkValidField("email")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.email}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="phone">
								<FormLabel>{this.props.t('providers.form.phone')}</FormLabel>
								<FormControl
									type="text"
									value={provider.phone}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.phone')}
									isInvalid={this.checkValidField("phone")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.phone}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
						<Col sm={6}>
							<FormGroup className="form-group" controlId="web">
								<FormLabel>{this.props.t('providers.form.web')}</FormLabel>
								<FormControl
									type="text"
									value={provider.web}
									onChange={this.handleChange}
									placeholder={this.props.t('providers.form.web')}
									isInvalid={this.checkValidField("web")}
								/>
								<FormControl.Feedback type="invalid">
									{this.state.errors.web}
								</FormControl.Feedback>
							</FormGroup>
						</Col>
					</Row>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t('common.save')}
						loadingText={this.props.t('common.saving')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.expensesReducer;
};

export default connect(mapStateToProps, expensesActions)(withTranslation()(ProviderEdit));
